import { PRODUCTS, PRODUCTS_BY_ID } from '../../../shared/constants/api';
import * as api from '../../../shared/services/apiClient';
import type { Product } from '../../../shared/types/models';

/**
 * Fetches a single product by ID.
 * @param {string} productId
 * @returns {Promise<Product | null>}
 */
export const getProductById = async (productId: string): Promise<Product | null> => {
  try {
    const res = await api.get(PRODUCTS_BY_ID(productId));
    if (!res.ok) return null;
    return await res.json();
  } catch (err) {
    console.error(`Failed to fetch product ${productId}:`, err);
    return null;
  }
};

/**
 * Fetches multiple products by their IDs using a batch query.
 * @param {string[]} productIds
 * @returns {Promise<Product[]>}
 */
export const getProductsByIds = async (productIds: string[]): Promise<Product[]> => {
  if (!productIds || productIds.length === 0) {
    return [];
  }

  const uniqueIds = [...new Set(productIds)];
  const whereClause = `id in ("${uniqueIds.join('", "')}")`;

  try {
    const res = await api.get(PRODUCTS, {
      where: whereClause,
      limit: String(uniqueIds.length),
      expand: 'masterData.current.masterVariant.prices[*].discounted.discount',
    });

    if (!res.ok) return [];
    const data = await res.json();
    return data.results || [];
  } catch (err) {
    console.error('Failed to fetch products by IDs:', err);
    return [];
  }
};
